import React, { FunctionComponent } from 'react';
import { Button, IButtonProps } from '../button/button';
import styles from './cta-button.module.scss';

export interface ICTAButtonProps {
  image: {
    url: string;
    description: string;
  };
  button: IButtonProps[];
  text: string;
}

export const CTAButton: FunctionComponent<ICTAButtonProps> = props => {
  const { button, image, text } = props;
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div dangerouslySetInnerHTML={{ __html: text }} />
        {button && (
          <div className={styles.buttonWrapper}>
            {button.map((item, i) => (
              <Button {...item} key={i} />
            ))}
          </div>
        )}
      </div>
      {image?.url && (
        <div className={styles.imageWrapper}>
          <div
            style={{ backgroundImage: `url(${image.url})` }}
            className={styles.image}
          />
        </div>
      )}
    </div>
  );
};
